import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ColorOption} from '../../../shared/models/appearance';
import {NgClass} from '@angular/common';
import {SpinnerComponent} from '../spinner/spinner.component';

@Component({
  selector: 'motn-stat-string',
  templateUrl: './stat-string.component.html',
  styleUrls: ['./stat-string.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
    SpinnerComponent,
  ],
})
export class StatStringComponent implements OnInit {

  @Input() datum: string | null;
  @Input() icon: string;
  @Input() title: string;
  @Input() color: ColorOption;

  constructor() {
  }

  ngOnInit(): void {
  }

}
